<template>
  <ListDropdown
    class="select-paginator"
    :value="currentPage.toString()"
    label="Seite wählen"
    :options="options"
    @select="onSelect"
  />
</template>

<script setup lang="ts">
import { range } from 'lodash-es';
import { withDefaults, computed } from 'vue';
import { ListDropdown } from '@i22/td-longtail-vue-components';
import type { FilterOption } from '@i22/td-longtail-vue-components/dist/components/dropdown/list-dropdown-helper';
import { useRouter } from '#imports';

type SelectPaginatorProps = {
  emitOnlyClick?: boolean;
  currentPage: number;
  totalPages: number;
  url: (page: number) => string;
  ariaLabelPrefix?: string;
  currentPageAriaLabel?: string;
};

const props = withDefaults(defineProps<SelectPaginatorProps>(), {
  ariaLabelPrefix: '',
  currentPageAriaLabel: '',
});

const emit = defineEmits<{
  (e: 'click', value: number): void;
}>();

const options = computed<FilterOption[]>(() =>
  range(1, props.totalPages + 1).map((p) => {
    const label = p.toString();
    let ariaLabel = label;

    if (props.ariaLabelPrefix) {
      ariaLabel = `${props.ariaLabelPrefix} ${p}`;
    }

    if (p === props.currentPage && props.currentPageAriaLabel) {
      ariaLabel = props.currentPageAriaLabel;
    }

    return {
      label,
      value: p.toString(),
      'aria-label': ariaLabel,
    };
  })
);

const $router = useRouter();

const onSelect = (newPage: string) => {
  const pageNumber = parseInt(newPage, 10);
  if (props.emitOnlyClick) {
    emit('click', pageNumber);
  } else {
    $router.push(props.url(pageNumber));
  }
};
</script>

<style lang="scss" scoped>
.select-paginator {
  :deep(.dropdown-container) {
    width: 150px;
  }
}
</style>
